import api from './index'
import {
	axios,
	pureAxios,
	pyAxios
} from '@/utils/request'
//危害因素列表
export function factor_list(parameter) {
	return axios({
		url: '/quote/quote/baseFactor/list',
		method: 'get',
		params: parameter
	})
}
//查询当前部门所有用户
export function getInDepts(parameter) {
	return axios({
		url: '/system/user/inDepts',
		method: 'get',
		params: parameter
	})
}
//查询当前用户信息
export function usreInfo(parameter) {
	return axios({
		url: '/system/user/info',
		method: 'get',
		params: parameter
	})
}
// 查询部门信息
export function getUsreInfo(key) {
	return axios({
		url: '/system/user/get/' + `${key}`,
		method: 'get',
	})
}

//查询详细危害因素列表
export function getUserListDetail(parameter) {
	return axios({
		url: '/quote/quote/factor/userList',
		method: 'get',
		params: parameter
	})
}
//查询危害因素列表
export function getFactorDetail(parameter) {
	return axios({
		url: '/quote/quote/factor/list',
		method: 'get',
		params: parameter
	})
}
// 删除危害因素
export function delete_factor(key) {
	return axios({
		url: '/quote/quote/baseFactor/' + `${key}`,
		method: 'delete'
	})
}
// 删除危害因素
export function baseFactorDelete(key) {
	return axios({
		url: '/quote/quote/baseFactor/delete/' + `${key}`,
		method: 'delete'
	})
}
//查询行业信息列表
export function industryInfo(parameter) {
	return axios({
		url: '/quote/quote/industryInfo/list',
		method: 'get',
		params: parameter
	})
}
//新增行业信息
export function industryInfo_post(parameter) {
	return axios({
		url: '/quote/quote/industryInfo',
		method: 'post',
		data: parameter
	})
}
//查询岗位信息列表
export function postInfo(parameter) {
	return axios({
		url: '/quote/quote/postInfo/list',
		method: 'get',
		params: parameter
	})
}
//获取客户信息列表
export function customerInfo(parameter) {
	return axios({
		url: '/quote/quote/customerInfo/list',
		method: 'get',
		params: parameter
	})
}
//获取企业详细信息
export function companyInfo_details(key) {
	return axios({
		url: '/quote/quote/companyInfo' + `${key}`,
		method: 'get'
	})
}
//查询客服信息列表
export function customerService(parameter) {
	return axios({
		url: '/quote/quote/customerService/list',
		method: 'get',
		params: parameter
	})
}
//新增岗位信息
export function addPostWithHarmFactor(parameter) {
	return axios({
		url: '/quote/quote/postInfo/addPostWithHarmFactor',
		method: 'post',
		data: parameter
	})
}
//编辑岗位信息
export function editPostWithHarmFactor(parameter) {
	return axios({
		url: '/quote/quote/postInfo/editPostWithHarmFactor',
		method: 'put',
		data: parameter
	})
}
//获取行业信息详细信息
export function industryInfo_details(key) {
	return axios({
		url: '/quote/quote/industryInfo/' + `${key}`,
		method: 'get'
	})
}
//修改行业信息
export function industryInfo_put(parameter) {
	return axios({
		url: '/quote/quote/industryInfo',
		method: 'put',
		data: parameter
	})
}
//删除行业信息
export function deleteIndustryInfo(key) {
	return axios({
		url: '/quote/quote/industryInfo/' + `${key}`,
		method: 'delete'
	})
}
//删除危害因素信息
//删除行业信息
export function deleteFactor(key) {
	return axios({
		url: '/quote/quote/factor/' + `${key}`,
		method: 'delete'
	})
}
//获取岗位信息详细信息
export function postInfo_details(key) {
	return axios({
		url: '/quote/quote/postInfo/' + `${key}`,
		method: 'get'
	})
}
//修改岗位信息
export function postInfo_put(parameter) {
	return axios({
		url: '/quote/quote/postInfo',
		method: 'put',
		data: parameter
	})
}
//获取报价单详细信息
export function quotation_details(key) {
	return axios({
		url: '/quote/quote/info/' + `${key}`,
		method: 'get'
	})
}
//获取客服代表
export function getCustomer(parameter) {
	return axios({
		url: '/quote/quote/customerService/getCustomerServiceInfo',
		method: 'get',
		data: parameter
	})
}
//获取客户详细信息
export function customerInfo_details(key) {
	return axios({
		url: '/quote/quote/customerInfo/' + `${key}`,
		method: 'get'
	})
}
//获取客服信息
export function getCustomerServiceInfo(parameter) {
	return axios({
		url: '/quote/quote/customerService/getCustomerServiceInfo',
		method: 'get',
		data: parameter
	})
}
//获取客服信息详细信息
export function customerService_details(key) {
	return axios({
		url: '/quote/quote/customerService/' + `${key}`,
		method: 'get'
	})
}
//编辑客户信息
export function customerInfo_edit(parameter) {
	return axios({
		url: '/quote/quote/customerInfo',
		method: 'put',
		data: parameter
	})
}
// 新增客服信息
export function addCustomerService(parameter) {
	return axios({
		url: '/quote/quote/customerService',
		method: 'POST',
		data: parameter
	})
}

//修改客服信息
export function customerService_put(parameter) {
	return axios({
		url: '/quote/quote/customerService',
		method: 'put',
		data: parameter
	})
}
//查询危害因素基础信息列表
export function baseFactor(parameter) {
	return axios({
		url: '/quote/quote/baseFactor/list',
		method: 'get',
		params: parameter
	})
}
//查询报价主分类列表
export function category(key) {
	return axios({
		url: '/quote/quote/category/list',
		method: 'get'
	})
}
//根据父类id--查询报价分类子类列表
export function subCategory(parameter) {
	return axios({
		url: '/quote/quote/subCategory/list',
		method: 'get',
		params: parameter
	})
}
//新增危害因素基础信息
export function baseFactor_add(parameter) {
	return axios({
		url: '/quote/quote/baseFactor',
		method: 'post',
		data: parameter
	})
}
// 获取危害因素详细信息
export function factor_details(key) {
	return axios({
		url: '/quote/quote/baseFactor/' + `${key}`,
		method: 'get'
	})
}
//修改危害因素详细信息
export function editFactors_put(parameter) {
	return axios({
		url: '/quote/quote/baseFactor',
		method: 'put',
		data: parameter
	})
}

//新增客户信息
export function customer_add(parameter) {
	return axios({
		url: '/quote/quote/customerInfo',
		method: 'post',
		data: parameter
	})
}
//新增企业信息
export function companyInfo_add(parameter) {
	return axios({
		url: '/quote/quote/companyInfo',
		method: 'post',
		data: parameter
	})
}
//查询地区列表
export function districts(parameter) {
	return axios({
		url: '/system/districts/tree',
		method: 'get',
		params: parameter
	})
}
//查询收费标准详细分类列表
export function getCategoryTree(parameter) {
	return axios({
		url: '/quote/quote/charge/getCategoryTree',
		method: 'get',
		params: parameter
	})
}
//查询报价检测主分类项目列表
export function items_list(parameter) {
	return axios({
		url: '/quote/quote/category/list',
		method: 'get',
		params: parameter
	})
}
//查询报价检测子分类项目列表
export function itemsChildren_list(parameter) {
	return axios({
		url: '/quote/quote/subCategory/list',
		method: 'get',
		params: parameter
	})
}
//获取责任物品信息
export function dutyAsset_list(parameter) {
	return axios({
		url: '/daily/asset/dutyAsset',
		method: 'get',
		params: parameter
	})
}
//获取保管物品信息
export function keeperAsset_list(parameter) {
	return axios({
		url: '/daily/asset/keeperAsset',
		method: 'get',
		params: parameter
	})
}
//替换责任人
export function replaceDuty_put(parameter) {
	return axios({
		url: '/daily/asset/replaceDuty',
		method: 'put',
		data: parameter
	})
}
//资产类别
export function  assetType_get(parameter) {
	return axios({
		url: '/system/dict/data/type',
		method: 'get',
		params: parameter
	})
}
// 删除客服代表
export function delete_customerService(key) {
	return axios({
		url: '/quote/quote/customerService/' + `${key}`,
		method: 'delete'
	})
}
//物品确认移交
export function trans(parameter) {
	return axios({
		url: '/daily/asset/trans',
		method: 'put',
		data: parameter
	})
}
//设为库存
export function keep_storage(parameter) {
	return axios({
		url: '/act/purchase_list/keep_storage',
		method: 'put',
		data: parameter
	})
}
//获取用户详细信息
export function user_details(key) {
	return axios({
		url: '/system/user/get/' + `${key}`,
		method: 'get'
	})
}
//新增报价单信息
export function addQuoteInfor(parameter) {
	return axios({
		url: '/quote/quote/info',
		method: 'post',
		data: parameter
	})
}
//获取获取报价检测项目
export function getItems(parameter) {
	return axios({
		url: '/quote/quote/items/getItems',
		method: 'get',
		params: parameter
	})
}
//新增报价单信息
export function addQuotation(parameter) {
	return axios({
		url: '/quote/quote/info',
		method: 'post',
		data: parameter
	})
}
//新增检测费用明细
export function addBatch(parameter) {
	return axios({
		url: '/quote/quote/details/addBatch',
		method: 'post',
		data: parameter
	})
}
//新增新增报价检测项目(自定义)
export function addQuoteSheetItemsBatch(parameter) {
	return axios({
		url: '/quote/quote/items/addQuoteSheetItemsBatch',
		method: 'post',
		data: parameter
	})
}
//修改报价检测项目
export function edititems(parameter) {
	return axios({
		url: '/quote/quote/items',
		method: 'put',
		data: parameter
	})
}
//查询岗位自定义列表
export function postInfo_list(parameter) {
	return axios({
		url: '/quote/quote/postInfo/getPostInfo',
		method: 'get',
		params: parameter
	})
}
//查询报价单信息列表
export function Pricelist(parameter) {
	return axios({
		url: '/quote/quote/info/list',
		method: 'get',
		params: parameter
	})
}
// 获取报价单信息详细信息
export function recordsDetails(key) {
	return axios({
		url: '/quote/quote/info/' + `${key}`,
		method: 'get'
	})
}
// 查询检测费用明细列表
export function detailsList(parameter) {
	return axios({
		url: '/quote/quote/details/list',
		method: 'get',
		params: parameter
	})
}
//到处报价单
export function exportPrice(parameter) {
	return axios({
		url: '/quote/quote/info/export',
		method: 'post',
		data: parameter
	})
}
//离职物品移交
export function assetTrans(parameter) {
	return axios({
		url: '/daily/asset/trans',
		method: 'put',
		data: parameter
	})
}
// 获取检测费用明细详细信息
export function testDetails(key) {
	return axios({
		url: '/quote/quote/details/' + `${key}`,
		method: 'get'
	})
}
// 查询报价检测项目列表
export function itemsList(parameter) {
	return axios({
		url: '/quote/quote/items/list',
		method: 'get',
		params: parameter
	})
}
//导出报价单(自定义)
export function infoExport(parameter) {
	return axios({
		url: '/quote/quote/info/export',
		method: 'post',
		data: parameter
	})
}
//导出合同
export function exportContract(parameter) {
	return axios({
		url: '/quote/quote/info/exportContract',
		method: 'post',
		data: parameter
	})
}
// 查询收费标准列表
export function subCategoryDetail(key) {
	return axios({
		url: '/quote/quote/subCategory/' + `${key}`,
		method: 'get'
	})
}
// 获取检测费用明细
export function getTestExpensesDetails(parameter) {
	return axios({
		url: '/quote/quote/items/getTestExpensesDetails',
		method: 'get',
		params: parameter
	})
}

// 获取危害因素下拉列表
export function getUserList(parameter) {
	return axios({
		url: 'quote/quote/baseFactor/userList',
		method: 'get',
		params: parameter
	})
}
export function exprot(parameter) {
	return axios({
		url: 'file/file/pre_pdf?path='+ parameter.path,
		method: 'get',
	})
}
//获取其他危害因素
export function getOtherFactor(parameter) {
	return axios({
		url: '/quote/quote/factor/app/base/list',
		method: 'get',
		params: parameter
	})
}
//获取检测性质列表、新增
export function getNatureList(parameter) {
	return axios({
		url: '/quote/quote/nature/list',
		method: 'get',
		params: parameter
	})
}
//获取检测性质列表编辑
export function getCheckedlist(parameter) {
	return axios({
		url: '/quote/quote/nature/getCheckedlist',
		method: 'get',
		params: parameter
	})
}
//选择检测类别
export function getRelationPollutantTypeGw(parameter) {
	return axios({
		url: '/quote/quote/pollutant/getRelationPollutantTypeGw',
		method: 'get',
		params: parameter
	})
}
//查询关联检测物质信息
export function getQuoteTestInfo(parameter) {
	return axios({
		url: '/quote/quote/testItem/getQuoteTestInfo',
		method: 'post',
		data: parameter
	})
}
//获取其他检测项目列表
export function getOtherTestItemInfoListForWeb(parameter) {
	return axios({
		url: '/quote/quote/testItem/getOtherTestItemInfoListForWeb',
		method: 'post',
		data: parameter
	})
}
// 添加其他检测项目
export function commitOtherTestItem(parameter) {
	return axios({
		url: '/quote/quote/testItem/commitOtherTestItem',
		method: 'post',
		data: parameter
	})
}
//获取添加检测项目页面数据
export function getTestItemInfo(parameter) {
	return axios({
		url: '/quote/quote/testItem/getTestItemInfo',
		method: 'post',
		data: parameter
	})
}
//删除检测项
export function removeNormalTestItem(parameter) {
	return axios({
		url: '/quote/quote/testItem/removeNormalTestItem',
		method: 'post',
		data: parameter
	})
}
//保存检测性质
export function saveTestNatureId(parameter) {
	return axios({
		url: '/quote/quote/testItem/saveTestNatureId',
		method: 'post',
		data: parameter
	})
}
